module.exports = __webpack_public_path__ + "static/media/contacts.7e09a336.svg";